import { AutomaticPayment } from './automatic-payment.model';
import { AchPaymentMethod, CreditCardPaymentMethod } from './payment-account.model';
import { ScheduledPayment } from './scheduled-payment.model';

export interface PaymentConfirmationModel {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [propName: string]: any;
  confirmationId?: string;
  paymentMethod?: {
    nickName?: string;
    date?: string;
    creditCard?: CreditCardPaymentMethod;
    achWithdrawal?: AchPaymentMethod;
  };
  paymentAccount?: string;
  automaticPayment?: AutomaticPayment;
  schedulePayment?: ScheduledPayment[];
  category: string;
  subCategory?: string;
  paymentId?: string;
  amount?: number;
  paymentConfirmationId?: string;
}
